import {Component, OnInit, ViewChild} from '@angular/core';
import {DeviceService} from "./device.service";
import {Device, DeviceStatus} from "../model/device.model";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {ActivatedRoute, Router} from "@angular/router";
import {UtilService} from "../shared/util.service";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
    selector: 'app-device',
    templateUrl: './device.component.html',
    styleUrls: ['./device.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class DeviceComponent implements OnInit {
  deviceStatuses = DeviceStatus;
  devices: Device[] = [];
  cacheKey = 'measure_filter_device';
  dataSource = new MatTableDataSource(this.devices);
  searchText = null;

  columnsToDisplay = ['name', 'status', 'target', 'type', 'company', 'site', 'modified', 'modifiedBy', 'action'];
  expandedElement: any | null;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(
    private service: DeviceService,
    private util: UtilService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.loadFilterCache();
    this.fetchItems();
    this.setDatatable();
  }

  fetchItems() {
    this.service.getSimpleItems().subscribe((resp:any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error);
      }
      this.devices = resp.map(r => new Device(r));
      this.dataSource.data = this.devices;
    })
  }

  loadFilterCache() {
    const filter = localStorage.getItem(this.cacheKey);
    if (filter) {
      this.searchText = filter;
      this.applyFilter();
    }
  }

  saveFilterCache() {
    localStorage.setItem(this.cacheKey, this.searchText);
  }

  setDatatable() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = this.util.tableSorting;
  }

  applyFilter() {
    this.saveFilterCache();
    this.dataSource.filter = this.searchText.trim().toLowerCase();
  }

  onEditDeviceClick(device) {
    return this.router.navigate(['/device', device.id]);
  }

  getDeviceInfoList(device) {
    this.service.getDeviceInfolist(device).subscribe((resp: any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error)
      }
      if (resp.length) {
        device.infoList = resp;
        this.expandedElement = device;
      }
    })
  }

  onRowClick(device) {
    if (this.expandedElement === device) {
      this.expandedElement = null;
    } else {
      this.getDeviceInfoList(device);
    }
  }
}
